/* Services and Modules */
import Convertor from "../../core/services/convertor";
import { convertLocationFromGemmiciAutocompleteItem } from "../services/SearchConvertor";
/* APIs */
import GeoappAPI from "../apis/gemmiciApiService/GeoappAPI";
import MapboxAPI from "../../core/apis/mapBoxApiService/MapboxAPI";
import SearchAPI from "../apis/gemmiciApiService/SearchAPI";

/* Classes */
import SearchDestinations from "../classes/SearchDestinations.js";
import SearchLocationAutocompleteItem from "../classes/SearchLocationAutocompleteItem";
import SearchPosts from "../classes/SearchPosts";
import SearchPostsInDestination from "../classes/SearchPostsInDestination";

// VARIABLES
import MAPBOX_FRANCE_ADMINISTRATIVES_ID from "../variables/mapboxFranceAdministrativesId.json";

export default {
  updateSearchLocationAutocompleteItems(search) {
    // initiate return value
    let destinations = [];
    // GetMapbox items
    MapboxAPI.searchAutocompleteAPI(search).then(response => {
      const mapBoxResult = response.data.features.filter(
        item => item.relevance > 0.5
      ).length;
      // add to destinations all MapBox Items above a relavance of 0.5
      for (let i = 0; i < mapBoxResult; i++) {
        const location = Convertor.convertLocationFromMapboxAutocompleteItem(
          response.data.features[i]
        );
        if (location.placeType === "department") {
          destinations.push(
            new SearchLocationAutocompleteItem(
              this.fromMapBoxRegionToGemmiciPlaceType(location)
            )
          );
        } else {
          destinations.push(new SearchLocationAutocompleteItem(location));
        }
      }
      if (destinations.length < 5) {
        SearchAPI.getGeoInformationsDestinationFromText(search).then(
          response => {
            for (let i = 0; i < 5 - mapBoxResult; i++) {
              if (response.data.features.length < i + 1) {
                break;
              }
              destinations.push(
                new SearchLocationAutocompleteItem(
                  convertLocationFromGemmiciAutocompleteItem(
                    response.data.features[i]
                  )
                )
              );
            }
          }
        );
      }
    });
    return destinations;
  },
  // transform placeType of Mapbox location that are France new region or departement
  fromMapBoxRegionToGemmiciPlaceType(location) {
    MAPBOX_FRANCE_ADMINISTRATIVES_ID.forEach(administrative => {
      if (administrative.id === location.id) {
        location.placeType = "administrative";
        return location;
      }
    });
    return location;
  },
  /* Update UrlParams (Destination, Theme, Bbox, Media, Page) */
  getSearchQueryParamsfromDestinationUpdate(urlParams, destination, radius) {
    delete urlParams.page;
    delete urlParams.username;
    delete urlParams.radius;
    if (destination.shortName !== "") {
      urlParams.longName = destination.longName;
      urlParams.shortName = destination.shortName;
      urlParams.placeType = destination.placeType;
      urlParams.xMin = destination.bbox[0];
      urlParams.xMax = destination.bbox[2];
      urlParams.yMin = destination.bbox[1];
      urlParams.yMax = destination.bbox[3];
      urlParams.longitude = destination.coordinates[0];
      urlParams.latitude = destination.coordinates[1];
      /poi|address|place|locality|neighborhood/.test(destination.placeType)
        ? (urlParams.radius = radius)
        : 0;
      return urlParams;
    } else {
      delete urlParams.shortName;
      delete urlParams.longName;
      delete urlParams.placeType;
      delete urlParams.xMax;
      delete urlParams.xMin;
      delete urlParams.yMin;
      delete urlParams.yMax;
      delete urlParams.longitude;
      delete urlParams.latitude;
      delete urlParams.radius;
      return urlParams;
    }
  },
  getSearchQueryParamsfromThemeUpdate(urlParams, themes) {
    delete urlParams.page;
    if (themes.length) {
      urlParams.themes = themes.map(x => x.name);
      return urlParams;
    } else {
      delete urlParams.themes;
      return urlParams;
    }
  },
  getSearchQueryParamsfromThemeSelectorUpdate(urlParams, media) {
    delete urlParams.page;
    urlParams.media = media;
    return urlParams;
  },
  getSearchQueryParamsfromBboxUpdate(urlParams, bbox) {
    delete urlParams.page;
    delete urlParams.shortName;
    delete urlParams.radius;
    delete urlParams.destinationId;
    urlParams.placeType = "bbox";
    urlParams.xMin = bbox.xMin;
    urlParams.xMax = bbox.xMax;
    urlParams.yMin = bbox.yMin;
    urlParams.yMax = bbox.yMax;
    return urlParams;
  },
  getSearchQueryParamsfromNavigatorLocation(
    urlParams,
    bbox,
    longitude,
    latitude,
    radius
  ) {
    delete urlParams.page;
    delete urlParams.placeType;
    delete urlParams.shortName;
    delete urlParams.longName;
    urlParams.xMin = bbox.xMin;
    urlParams.xMax = bbox.xMax;
    urlParams.yMin = bbox.yMin;
    urlParams.yMax = bbox.yMax;
    urlParams.longitude = longitude;
    urlParams.latitude = latitude;
    urlParams.placeType = "myPosition";
    urlParams.radius = radius;
    return urlParams;
  },
  getSearchQueryParamsfromPageUpdate(urlParams, number) {
    number == 1 ? delete urlParams.page : (urlParams.page = number);
    return urlParams;
  },
  getSearchQueryParamsfromParameterUpdate(urlParams, value, parameter) {
    urlParams[parameter] = value;
    return urlParams;
  },
  getSearchQueryFromRegionName(regionName) {
    let query = {};
    return new Promise((resolve, reject) => {
      GeoappAPI.retrieveRegionAPI(regionName)
        .then(response => {
          response.data.shortName.length > 0 ? 0 : reject();
          query.xMin = response.data.bbox[0];
          query.xMax = response.data.bbox[2];
          query.yMin = response.data.bbox[1];
          query.yMax = response.data.bbox[3];
          query.longName = response.data.longName;
          query.shortName = response.data.shortName;
          resolve(query);
        })
        .catch(err => reject(err));
    });
  },
  getSearchQueryFromDepartmentName(departmentName) {
    let query = {};
    return new Promise((resolve, reject) => {
      GeoappAPI.retrieveDepartmentAPI(departmentName)
        .then(response => {
          response.data.shortName.length > 0 ? 0 : reject();
          query.xMin = response.data.bbox[0];
          query.xMax = response.data.bbox[2];
          query.yMin = response.data.bbox[1];
          query.yMax = response.data.bbox[3];
          query.longName = response.data.longName;
          query.shortName = response.data.shortName;
          resolve(query);
        })
        .catch(err => reject(err));
    });
  },
  getSearchQueryFromAdministrativeName(administrativeName) {
    let query = {};
    return new Promise((resolve, reject) => {
      GeoappAPI.retrieveAdministrativeAPI(administrativeName)
        .then(response => {
          response.data.shortName.length > 0 ? 0 : reject();
          query.xMin = response.data.bbox[0];
          query.xMax = response.data.bbox[2];
          query.yMin = response.data.bbox[1];
          query.yMax = response.data.bbox[3];
          query.longName = response.data.longName;
          query.shortName = response.data.shortName;
          resolve(query);
        })
        .catch(err => reject(err));
    });
  },
  getSearchQueryParamsfromUpdateRadius(
    urlParams,
    bbox,
    longitude,
    latitude,
    radius
  ) {
    urlParams.xMin = bbox.xMin;
    urlParams.xMax = bbox.xMax;
    urlParams.yMin = bbox.yMin;
    urlParams.yMax = bbox.yMax;
    urlParams.longitude = longitude;
    urlParams.latitude = latitude;
    urlParams.radius = radius;
    return urlParams;
  },
  getBboxFromCoordsAndRadius(longitude, latitude, radius) {
    const OneKmToDegrees = 0.0089982311915998;
    let bbox = {};
    bbox.xMin = longitude - radius * OneKmToDegrees;
    bbox.xMax = longitude + radius * OneKmToDegrees;
    bbox.yMin = latitude - radius * OneKmToDegrees;
    bbox.yMax = latitude + radius * OneKmToDegrees;
    return bbox;
  },
  getCoordsFromBbox(bbox) {
    const longitude = (bbox[0] + bbox[2]) / 2;
    const latitude = (bbox[1] + bbox[3]) / 2;
    return [longitude, latitude];
  },
  /* API calls */
  getCityBboxFromCoordinates(longitude, latitude) {
    return new Promise(resolve => {
      GeoappAPI.retrieveCityAPI({ longitude, latitude }).then(response =>
        resolve(response.data.bbox)
      );
    });
  },
  getEmptySearchPosts() {
    return new SearchPosts();
  },
  getSearchPosts(searchParams) {
    return new Promise(resolve => {
      SearchAPI.getSearchPostsAPI(searchParams.getDataForNewSearch())
        .then(response => {
          resolve(new SearchPosts(response.data));
        })
        .catch(err => reject(err));
    });
  },
  getEmptySearchDestinations() {
    return new SearchDestinations();
  },
  getSearchDestinations(searchParams) {
    return new Promise((resolve, reject) => {
      SearchAPI.getDestinationsAPI(searchParams.getDataForNewSearch())
        .then(response => {
          resolve(new SearchDestinations(response.data));
        })
        .catch(err => reject(err));
    });
  },
  getDestinationSearchPosts(searchDestinationParams) {
    return new Promise((resolve, reject) => {
      SearchAPI.getPostsInDestination(
        searchDestinationParams.getDataForNewSearch()
      )
        .then(response => {
          resolve(new SearchPostsInDestination(response.data));
        })
        .catch(err => reject(err));
    });
  }
};
